// Copyright (c) 2019 Deere & Company

import {
    isNotEmpty,
    isNotNull,
    isRepairDateAfterFailureDate,
    validateClaimUseAmountUnits,
    validateClaimUseAmounts
} from '../../shared/services/claim-shared-helper';
import WearPartsClaim from '@deere/cps-it.warranty-model-factory/lib/claim-wear-part';
import {removeEmptyRows} from '../../shared/services/empty-claim-rows';

const hasAtLeastOneClaimItem = claim =>
    claim.parts.length || claim.labor.length || claim.otherCredits.length;

export const canShowAllSections = (claimNumber, isValidClaim) =>
    isValidClaim || isNotEmpty(claimNumber);

export const isValidClaim = claim => [
    isNotEmpty(claim.failureInfo.failurePartNumber),
    isNotEmpty(claim.pin),
    validateClaimUseAmounts('', claim),
    validateClaimUseAmountUnits('', claim),
    isNotEmpty(claim.responsibleAccount.account),
    isNotEmpty(claim.referenceInfo.ownershipStatus.key),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isNotNull(claim.failureInfo.failureDate),
    isNotNull(claim.failureInfo.repairDate),
    isRepairDateAfterFailureDate(claim.failureInfo.repairDate, claim.failureInfo.failureDate)
].every(rule => rule);

export const saveValidate = claim => [
    isValidClaim(claim),
    isNotEmpty(claim.additionalFailureInfo.failureMode.key),
    isNotEmpty(claim.additionalFailureInfo.failureArea),
    isNotEmpty(claim.additionalFailureInfo.downtime.key),
    isNotEmpty(claim.complaintCauseCommentsBasis.howWasComplaintCorrected),
    isNotEmpty(claim.complaintCauseCommentsBasis.basisForSettlement),
    hasAtLeastOneClaimItem(removeEmptyRows(claim, WearPartsClaim))
].every(rule => rule);

export const mapFormValidation = (property, value, claim) => {

    const map = {
        basisForSettlement: isNotEmpty,
        complaintCorrection: isNotEmpty,
        downtime: isNotEmpty,
        failureArea: isNotEmpty,
        failureDate: isNotNull,
        failureMode: isNotEmpty,
        failurePart: isNotEmpty,
        ownershipStatus: isNotEmpty,
        pin: isNotEmpty,
        repairDate: isNotNull,
        responsibleAccount: isNotEmpty,
        useAmount: validateClaimUseAmounts,
        useAmountUnit: validateClaimUseAmountUnits,
        workOrderOne: isNotEmpty
    };

    return map[property](value, claim);

};

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) =>
    selectedAction === 'VALIDATE' ?
        !validationFailed && !currentPageValidity :
        false;



// WEBPACK FOOTER //
// ./src/claim/wear-parts/services/claim-validation-helper.js